import { CardHeader, Nav, NavItem, TabContent } from "reactstrap"
import styled from "styled-components"

export const StyledCardHeader = styled(CardHeader).attrs(() => ({
    className: ""
}))`background: #efefef;
font-family: "baloo";`

export const StyledButtonOne = styled.button.attrs(() => ({
    className: "btn btn-primary p-2", type: "button"
}))`margin-top: "4px";`

export const StyledButtonTwo = styled.button.attrs(() => ({
    className: "btn btn-danger", type: "button"
}))`margin-top: "4px";
margin-left: ".75rem";
`

export const StyledNav = styled(Nav).attrs(() => ({
    fill: true,
    pills: true,
    className: ""
}))`font-family: "Baloo";
background: #f3f4fb;`


export const StyledNavItem = styled(NavItem).attrs(() => ({
    className: "pr-0"
}))`flex-grow: 1;
flex-basis: calc(100% / 2);`


export const StyledTabContent = styled(TabContent).attrs(() => ({
    className: "p-3"
}))`background: #fffefeb0 !important;
box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
`